export const ORG_LOGOUT = "org-logout";
export const MAIN_APP = "main_app";
export const ORG_NAV_ITEM = "org-navItem";
export const ORG_NAV_LINK = "org-navLink";
export const PAGE_404_APP = "page-404-app";
export const PAGE_403_APP = "page-403-app";
export const NAVBAR = "navbar";
export const THEME_TOGGLE = "theme-toggle";
